const getters = {
    baseConfig: state => state.settings.baseConfig,
    userInfo: state => state.user.userInfo,
}
export default getters
  